@if (assessmentReview) {
  <mat-card appearance="outlined" class="capture-event-assessment-review-detail-map-popup">
    <mat-card-content fxLayout="row">
      <mat-tab-group mat-stretch-tabs="false" (selectedTabChange)="selectReview(+$event.tab.textLabel)" [(selectedIndex)]="activeTab" fxFlex="100%" animationDuration="0ms">
        @for (view of captureEvent.views; track view) {
          <div>
            @for (tabReview of view.assessmentReviews; track tabReview) {
              <mat-tab label="{{tabReview.id}}">
                <ng-template mat-tab-label>
                  {{ view.viewType | startCase }}
                </ng-template>
                <div fxLayout="row" fxLayoutGap="10px">
                  <div class="review-popup-info" fxLayout="column">
                    <ng-container *ngTemplateOutlet="assessmentReviewDetailTemplate; context: { $implicit: tabReview }"></ng-container>
                    @if (inspectAssessment) {
                      <mat-list class="dense-detail-list">
                        <mat-list-item>
                          <span matListItemTitle>{{ inspectAssessment.description }}</span>
                          <span matListItemLine>Assessment </span>
                        </mat-list-item>
                        @if (assessmentReview.assessmentResult) {
                          <mat-list-item>
                            <span matListItemTitle>{{ assessmentReview.assessmentResult }}</span>
                            <span matListItemLine>Result </span>
                          </mat-list-item>
                        }
                      </mat-list>
                    }
                  </div>
                  <mat-tab-group mat-stretch-tabs="false" class="imageTabGroup" animationDuration="0ms">
                    @for (image of assessmentReview.images; track image) {
                      <mat-tab label="{{image.description }}">
                        <img src="{{image.url}}" alt="assessment review image"/>
                      </mat-tab>
                    }
                  </mat-tab-group>
                </div>
              </mat-tab>
            }
          </div>
        }
      </mat-tab-group>
      <div fxLayoutAlign="end start">
        <button mat-icon-button (click)="onClose()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-card-content>
  </mat-card>
}
